(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-all-products"]) return;
  try {
    
  (function () {
    function initCatalogs() {
      document.querySelectorAll('[data-rc]').forEach(function (root) {
        if (root.dataset.ready) return;
        root.dataset.ready = '1';
        const grid = root.querySelector('[data-rc-grid]');
        const cards = Array.from(root.querySelectorAll('[data-rc-card]'));
        const search = root.querySelector('[data-rc-search]');
        const stock = root.querySelector('[data-rc-stock]');
        const sort = root.querySelector('[data-rc-sort]');
        const normalize = function (value) {
          return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        };

        function update() {
          const query = normalize(search.value.trim());
          let count = 0;
          const ordered = Array.from(cards);
          if (sort.value === 'price-up') ordered.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
          if (sort.value === 'price-down') ordered.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
          if (sort.value === 'title') ordered.sort(function (a, b) { return a.dataset.title.localeCompare(b.dataset.title, 'es'); });

          ordered.forEach(function (card) {
            card.hidden = !normalize(card.dataset.title).includes(query) || (stock.checked && card.dataset.available !== 'true');
            if (!card.hidden) count += 1;
            grid.append(card);
          });

          root.querySelector('[data-rc-count]').textContent = `${count} / ${cards.length}`;
          root.querySelector('[data-rc-empty]').hidden = count > 0;
        }

        search.addEventListener('input', update);
        stock.addEventListener('change', update);
        sort.addEventListener('change', update);

        const header = document.querySelector('[data-mush-header]');
        if (header) {
          const measure = function () {
            document.body.style.setProperty('--rc-header', `${Math.ceil(header.getBoundingClientRect().height)}px`);
          };
          measure();
          new ResizeObserver(measure).observe(header);
        }
      });
    }

    if (!window.romaltaCatalogAddReady) {
      window.romaltaCatalogAddReady = true;
      document.addEventListener('click', async function (event) {
        const button = event.target.closest('[data-rc-add]');
        if (!button || button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname,
            }),
          });

          if (!response.ok) throw new Error('cart-add-failed');
          const state = await response.json();
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(state);
          } else {
            window.location.assign(window.Shopify.routes.root + 'cart');
          }
        } catch (error) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCatalogs);
    } else {
      initCatalogs();
    }
    document.addEventListener('shopify:section:load', initCatalogs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-aroma-video"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(){document.querySelectorAll('[data-ra-loop]').forEach(v=>{if(v.dataset.ready)return;v.dataset.ready='1';let manual=false,visible=false,loaded=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)');const update=()=>v.setAttribute('aria-pressed',String(!v.paused));const start=()=>{if(!loaded){const source=v.querySelector('source');source.src=source.dataset.src;v.load();loaded=true;}v.play().catch(update);};const toggle=()=>{if(v.paused){manual=false;start();}else{manual=true;v.pause();}update();};v.addEventListener('click',toggle);v.addEventListener('keydown',e=>{if(e.key===' '||e.key==='Enter'){e.preventDefault();toggle();}});v.addEventListener('play',update);v.addEventListener('pause',update);v.addEventListener('ended',()=>{if(!manual&&visible&&!document.hidden&&!reduced.matches){v.currentTime=0;start();}});v.addEventListener('contextmenu',e=>e.preventDefault());const auto=()=>{if(visible&&!document.hidden&&!manual&&!reduced.matches)start();else v.pause();};if('IntersectionObserver'in window)new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;auto();},{threshold:.3}).observe(v);document.addEventListener('visibilitychange',auto);reduced.addEventListener('change',auto);});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-box-main"] && !Shopify.designMode) return;
  try {
    
(function(){function setup(){document.querySelectorAll('[data-box]').forEach(function(root){if(root.dataset.ready)return;root.dataset.ready='true';
const copy=JSON.parse(root.querySelector('[data-box-copy]').textContent);const variants=JSON.parse(root.querySelector('[data-box-variants]').textContent),select=root.querySelector('[data-box-variant]'),form=root.querySelector('form'),photo=root.querySelector('[data-box-photo]'),radios=[...root.querySelectorAll('input[type="radio"][name="quantity"]')],buttons=[...root.querySelectorAll('.box-actions button')],status=root.querySelector('[data-box-status]');
const money=c=>new Intl.NumberFormat('es-PE',{style:'currency',currency:root.dataset.currency}).format(c/100);
const variant=()=>variants.find(v=>v.id===select.value);let busy=false;
function showImage(src,alt){if(!src)return;photo.src=src;photo.alt=alt;root.querySelectorAll('[data-box-thumb]').forEach(b=>b.setAttribute('aria-current',String(b.dataset.boxThumb===src)))}
root.querySelectorAll('[data-box-thumb]').forEach(b=>b.addEventListener('click',()=>showImage(b.dataset.boxThumb,b.dataset.alt)));
function sync(changeImage){const v=variant();if(!v)return;root.querySelector('[data-box-price]').textContent=money(v.price);if(radios.length){root.querySelector('[data-box-one]').textContent=money(v.price);root.querySelector('[data-box-pair]').textContent=money((v.price-2000)*2);root.querySelector('[data-box-each]').textContent=money(v.price-2000)+copy.s0;root.querySelector('[data-box-regular]').textContent=money(v.price*2);radios.forEach(r=>r.disabled=!v.available||Number(r.value)>v.remaining);if(radios.find(r=>r.checked)?.disabled){const first=radios.find(r=>!r.disabled);if(first)first.checked=true}}
buttons.forEach(b=>b.disabled=busy||!v.available||v.remaining<1);if(changeImage){showImage(v.image,copy.s1+v.title);const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}
}
root.querySelectorAll('[data-color-photo]').forEach(c=>c.addEventListener('change',()=>showImage(c.dataset.colorPhoto,c.value)));select.addEventListener('change',()=>sync(true));sync(false);
form.addEventListener('submit',async function(e){e.preventDefault();if(busy)return;const v=variant(),data=new FormData(form),qty=Number(data.get('quantity'));if(!v||!v.available||!Number.isInteger(qty)||qty<1||qty>v.remaining){status.textContent=copy.s2;return}const checkout=e.submitter?.hasAttribute('data-box-checkout');busy=true;sync(false);status.textContent=copy.s3;try{const base=window.Shopify?.routes?.root||'/';const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:qty,properties:{Color:data.get('properties[Color]')}}]})});const result=await response.json();if(!response.ok)throw new Error(result.description||copy.s4);v.remaining-=qty;status.textContent=copy.s5;window.location.assign(checkout?base+'checkout':root.dataset.cartUrl)}catch(error){status.textContent=error.message||copy.s4}finally{busy=false;sync(false)}});
const header=document.querySelector('[data-mush-header]');if(header){const measure=()=>document.body.style.setProperty('--box-header',Math.ceil(header.getBoundingClientRect().height)+'px');measure();new ResizeObserver(measure).observe(header)}
})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();document.addEventListener('shopify:section:load',setup)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-box-media"] && !Shopify.designMode) return;
  try {
    
(function(){function init(){document.querySelectorAll('[data-box-video]').forEach(v=>{if(v.dataset.ready)return;v.dataset.ready='true';const copy=JSON.parse(v.closest('.box-media').querySelector('[data-box-video-copy]').textContent);const p=v.parentElement.querySelector('[data-box-pause]'),s=v.parentElement.querySelector('[data-box-sound]');let userPaused=false;v.muted=true;function load(){const src=v.querySelector('source');if(!src.src){src.src=src.dataset.src;v.load()}}function update(){p.textContent=v.paused?copy.s0:copy.s1;s.textContent=v.muted?copy.s2:copy.s3;s.setAttribute('aria-pressed',String(!v.muted))}function play(){load();v.play().catch(update)}p.addEventListener('click',()=>{if(v.paused){userPaused=false;play()}else{userPaused=true;v.pause()}});s.addEventListener('click',()=>{const on=v.muted;document.querySelectorAll('[data-box-video]').forEach(other=>{if(other!==v)other.muted=true});v.muted=!on;update()});['play','pause','volumechange'].forEach(e=>v.addEventListener(e,update));v.addEventListener('ratechange',()=>{if(v.playbackRate!==1)v.playbackRate=1});v.addEventListener('contextmenu',e=>e.preventDefault());if('IntersectionObserver' in window)new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting&&!userPaused)play();else v.pause()}),{threshold:.25}).observe(v);else play();update()})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-clock-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(scope){scope.querySelectorAll('[data-clock-carousel]').forEach(function(root){
if(root.dataset.ready)return;root.dataset.ready='true';
var slides=Array.from(root.querySelectorAll('[data-clock-slide]')),dots=Array.from(root.querySelectorAll('[data-clock-dot]')),current=0;
function show(n){current=(n+slides.length)%slides.length;slides.forEach(function(slide,i){slide.hidden=i!==current});dots.forEach(function(dot,i){if(i===current)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')})}
root.querySelector('[data-clock-prev]').addEventListener('click',function(){show(current-1)});
root.querySelector('[data-clock-next]').addEventListener('click',function(){show(current+1)});
dots.forEach(function(dot,i){dot.addEventListener('click',function(){show(i)})});
root.addEventListener('keydown',function(e){if(e.target.tagName!=='BUTTON')return;if(e.key==='ArrowRight'){e.preventDefault();show(current+1)}if(e.key==='ArrowLeft'){e.preventDefault();show(current-1)}});
var start=null;root.addEventListener('touchstart',function(e){if(e.touches.length===1)start={x:e.touches[0].clientX,y:e.touches[0].clientY}},{passive:true});root.addEventListener('touchend',function(e){if(!start||!e.changedTouches.length)return;var dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))show(current+(dx<0?1:-1))},{passive:true});
})}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);
document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-collection-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-mush-header]').forEach((header) => {
      if (header.dataset.ready === 'true') return;
      header.dataset.ready = 'true';

      let ticking = false;
      const updateHeader = () => {
        header.classList.toggle('is-scrolled', window.scrollY > 24);
        ticking = false;
      };

      updateHeader();

      window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateHeader);
      }, { passive: true });

      document.addEventListener('click', (event) => {
        header.querySelectorAll('details[open]').forEach((details) => {
          if (!details.contains(event.target)) details.removeAttribute('open');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-home-human"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const setup=()=>{
      document.documentElement.classList.add('rhm-js');
      const root=document.querySelector('[data-rhm-home]');
      if(!root||root.dataset.ready==='true')return;
      root.dataset.ready='true';
      const videos=Array.from(root.querySelectorAll('[data-rhm-video]'));
      const tones=Array.from(root.querySelectorAll('[data-rhm-tone]'));
      const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
      const loadVideo=video=>{
        const source=video.querySelector('source[data-src]');
        if(source&&!source.src){
          source.src=source.dataset.src;
          video.load();
        }
      };
      const playVideo=video=>{
        if(!video||reduced)return;
        loadVideo(video);
        const promise=video.play();
        if(promise)promise.catch(()=>{});
      };
      videos.forEach(video=>video.addEventListener('ended',()=>{video.currentTime=0;playVideo(video)}));
      if('IntersectionObserver'in window){
        const revealObserver=new IntersectionObserver(entries=>{
          entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');revealObserver.unobserve(entry.target)}});
        },{rootMargin:'0px 0px -8%',threshold:.08});
        root.querySelectorAll('[data-rhm-reveal]').forEach(element=>revealObserver.observe(element));
        const loadObserver=new IntersectionObserver(entries=>{
          entries.forEach(entry=>{if(entry.isIntersecting){const video=entry.target;loadVideo(video);loadObserver.unobserve(video)}});
        },{rootMargin:'350px 0px'});
        videos.forEach(video=>{if(video.querySelector('source[data-src]'))loadObserver.observe(video)});
        const playbackObserver=new IntersectionObserver(entries=>{
          entries.forEach(entry=>{if(entry.isIntersecting)playVideo(entry.target);else entry.target.pause()});
        },{threshold:.3});
        videos.forEach(video=>playbackObserver.observe(video));
        const toneObserver=new IntersectionObserver(entries=>{
          entries.forEach(entry=>{
            if(entry.isIntersecting){
              tones.forEach(item=>item.classList.toggle('is-active',item===entry.target));
              root.dataset.active=entry.target.dataset.rhmTone;
            }
          });
        },{rootMargin:'-35% 0px -35%',threshold:0});
        tones.forEach(item=>toneObserver.observe(item));
      }else{
        root.querySelectorAll('[data-rhm-reveal]').forEach(element=>element.classList.add('is-visible'));
        videos.forEach(playVideo);
      }
      document.addEventListener('visibilitychange',()=>{
        if(document.hidden)videos.forEach(video=>video.pause());
        else videos.forEach(video=>{if(video.getBoundingClientRect().top<innerHeight&&video.getBoundingClientRect().bottom>0)playVideo(video)});
      });
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
    document.addEventListener('shopify:section:load',setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-locator-main"] && !Shopify.designMode) return;
  try {
    
(function(){function setup(){document.querySelectorAll('[data-locator]').forEach(function(root){if(root.dataset.ready)return;root.dataset.ready='true';
const copy=JSON.parse(root.querySelector('[data-loc-copy]').textContent);const variants=JSON.parse(root.querySelector('[data-loc-variants]').textContent),select=root.querySelector('[data-loc-variant]'),form=root.querySelector('form'),photo=root.querySelector('[data-loc-photo]'),radios=[...root.querySelectorAll('input[type="radio"][name="quantity"]')],buttons=[...root.querySelectorAll('.loc-actions button')],status=root.querySelector('[data-loc-status]');
const money=c=>new Intl.NumberFormat('es-PE',{style:'currency',currency:root.dataset.currency}).format(c/100);
const variant=()=>variants.find(v=>v.id===select.value);let busy=false;
function showImage(src,alt){if(!src)return;photo.src=src;photo.alt=alt;root.querySelectorAll('[data-loc-thumb]').forEach(b=>b.setAttribute('aria-current',String(b.dataset.locThumb===src)))}
root.querySelectorAll('[data-loc-thumb]').forEach(b=>b.addEventListener('click',()=>showImage(b.dataset.locThumb,b.dataset.alt)));
function sync(changeImage){const v=variant();if(!v)return;root.querySelector('[data-loc-price]').textContent=money(v.price);if(radios.length){root.querySelector('[data-loc-one]').textContent=money(v.price);root.querySelector('[data-loc-pair]').textContent=money((v.price-1000)*2);root.querySelector('[data-loc-each]').textContent=money(v.price-1000)+copy.s0;root.querySelector('[data-loc-regular]').textContent=money(v.price*2);radios.forEach(r=>r.disabled=!v.available||Number(r.value)>v.remaining);if(radios.find(r=>r.checked)?.disabled){const first=radios.find(r=>!r.disabled);if(first)first.checked=true}}
buttons.forEach(b=>b.disabled=busy||!v.available||v.remaining<1);if(changeImage){showImage(v.image,copy.s1+v.title);const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}
}
select.addEventListener('change',()=>sync(true));sync(new URL(location.href).searchParams.has('variant'));
form.addEventListener('submit',async function(e){e.preventDefault();if(busy)return;const v=variant(),data=new FormData(form),qty=Number(data.get('quantity'));if(!v||!v.available||!Number.isInteger(qty)||qty<1||qty>v.remaining){status.textContent=copy.s2;return}const checkout=e.submitter?.hasAttribute('data-loc-checkout');busy=true;sync(false);status.textContent=copy.s3;try{const base=window.Shopify?.routes?.root||'/';const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:qty}]})});const result=await response.json();if(!response.ok)throw new Error(result.description||copy.s4);v.remaining-=qty;status.textContent=copy.s5;window.location.assign(checkout?base+'checkout':root.dataset.cartUrl)}catch(error){status.textContent=error.message||copy.s4}finally{busy=false;sync(false)}});
const header=document.querySelector('[data-mush-header]');if(header){const measure=()=>document.body.style.setProperty('--loc-header',Math.ceil(Math.max(header.getBoundingClientRect().height,header.getBoundingClientRect().bottom))+'px');measure();new ResizeObserver(measure).observe(header)}
})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();document.addEventListener('shopify:section:load',setup)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-locator-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(scope){scope.querySelectorAll('[data-locator-review-carousel]').forEach(function(root){
if(root.dataset.ready)return;root.dataset.ready='true';
var slides=Array.from(root.querySelectorAll('[data-locator-review-slide]')),dots=Array.from(root.querySelectorAll('[data-locator-review-dot]')),current=0;
function show(n){current=(n+slides.length)%slides.length;slides.forEach(function(slide,i){slide.hidden=i!==current});dots.forEach(function(dot,i){if(i===current)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')})}
root.querySelector('[data-locator-review-prev]').addEventListener('click',function(){show(current-1)});
root.querySelector('[data-locator-review-next]').addEventListener('click',function(){show(current+1)});
dots.forEach(function(dot,i){dot.addEventListener('click',function(){show(i)})});
root.addEventListener('keydown',function(e){if(e.target.tagName!=='BUTTON')return;if(e.key==='ArrowRight'){e.preventDefault();show(current+1)}if(e.key==='ArrowLeft'){e.preventDefault();show(current-1)}});
var start=null;root.addEventListener('touchstart',function(e){if(e.touches.length===1)start={x:e.touches[0].clientX,y:e.touches[0].clientY}},{passive:true});root.addEventListener('touchend',function(e){if(!start||!e.changedTouches.length)return;var dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))show(current+(dx<0?1:-1))},{passive:true});
})}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);
document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-locator-story"] && !Shopify.designMode) return;
  try {
    
(function(){function init(){document.querySelectorAll('[data-loc-video]').forEach(video=>{if(video.dataset.ready)return;video.dataset.ready='true';const copy=JSON.parse(video.closest('.loc-story').querySelector('[data-loc-copy]').textContent);const button=video.parentElement.querySelector('[data-loc-video-toggle]');const sound=video.parentElement.querySelector('[data-loc-video-sound]');let pausedByUser=false;video.muted=true;video.defaultMuted=true;const update=()=>{sound.textContent=video.muted?copy.soundOn:copy.soundOff;sound.setAttribute('aria-pressed',String(!video.muted));button.textContent=video.paused?copy.s0:copy.s1;button.setAttribute('aria-label',video.paused?copy.s2:copy.s3)};const play=()=>video.play().catch(update);button.addEventListener('click',()=>{if(video.paused){pausedByUser=false;play()}else{pausedByUser=true;video.pause()}});sound.addEventListener('click',()=>{video.muted=!video.muted;video.volume=1;update()});video.addEventListener('volumechange',update);video.addEventListener('play',update);video.addEventListener('pause',update);video.addEventListener('ratechange',()=>{if(video.playbackRate!==1)video.playbackRate=1});video.addEventListener('contextmenu',e=>e.preventDefault());if('IntersectionObserver' in window)new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting&&!pausedByUser)play();else video.pause()}),{threshold:.2}).observe(video);else play();update()})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-n7-main"] && !Shopify.designMode) return;
  try {
    
(function(){function setup(){document.querySelectorAll('[data-massage]').forEach(function(root){if(root.dataset.ready)return;root.dataset.ready='true';
const copy=JSON.parse(root.querySelector('[data-n7-copy]').textContent);const variants=JSON.parse(root.querySelector('[data-n7-variants]').textContent),select=root.querySelector('[data-n7-variant]'),form=root.querySelector('form'),photo=root.querySelector('[data-n7-photo]'),radios=[...root.querySelectorAll('input[type="radio"][name="quantity"]')],buttons=[...root.querySelectorAll('.n7-actions button')],status=root.querySelector('[data-n7-status]');
const money=c=>new Intl.NumberFormat('es-PE',{style:'currency',currency:root.dataset.currency}).format(c/100);
const variant=()=>variants.find(v=>v.id===select.value);let busy=false;
function showImage(src,alt){if(!src)return;photo.src=src;photo.alt=alt;root.querySelectorAll('[data-n7-thumb]').forEach(b=>b.setAttribute('aria-current',String(b.dataset.n7Thumb===src)))}
root.querySelectorAll('[data-n7-thumb]').forEach(b=>b.addEventListener('click',()=>showImage(b.dataset.n7Thumb,b.dataset.alt)));
function sync(changeImage){const v=variant();if(!v)return;root.querySelector('[data-n7-price]').textContent=money(v.price);if(radios.length){root.querySelector('[data-n7-one]').textContent=money(v.price);root.querySelector('[data-n7-pair]').textContent=money((v.price-2000)*2);root.querySelector('[data-n7-each]').textContent=money(v.price-2000)+copy.s0;root.querySelector('[data-n7-regular]').textContent=money(v.price*2);radios.forEach(r=>r.disabled=!v.available||Number(r.value)>v.remaining);if(radios.find(r=>r.checked)?.disabled){const first=radios.find(r=>!r.disabled);if(first)first.checked=true}}
buttons.forEach(b=>b.disabled=busy||!v.available||v.remaining<1);if(changeImage){showImage(v.image,copy.s1+v.title);const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}
}
select.addEventListener('change',()=>sync(true));sync(new URL(location.href).searchParams.has('variant'));
form.addEventListener('submit',async function(e){e.preventDefault();if(busy)return;const v=variant(),data=new FormData(form),qty=Number(data.get('quantity'));if(!v||!v.available||!Number.isInteger(qty)||qty<1||qty>v.remaining){status.textContent=copy.s2;return}const checkout=e.submitter?.hasAttribute('data-n7-checkout');busy=true;sync(false);status.textContent=copy.s3;try{const base=window.Shopify?.routes?.root||'/';const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:qty}]})});const result=await response.json();if(!response.ok)throw new Error(result.description||copy.s4);v.remaining-=qty;status.textContent=copy.s5;window.location.assign(checkout?base+'checkout':root.dataset.cartUrl)}catch(error){status.textContent=error.message||copy.s4}finally{busy=false;sync(false)}});
const header=document.querySelector('[data-mush-header]');if(header){const measure=()=>document.body.style.setProperty('--n7-header',Math.ceil(header.getBoundingClientRect().height)+'px');measure();new ResizeObserver(measure).observe(header)}
})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();document.addEventListener('shopify:section:load',setup)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-n7-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initReviewSliders(scope){
    (scope || document).querySelectorAll('[data-n7-review-slider]').forEach(function(slider){
      if(slider.dataset.rmReviewReady === 'true') return;
      slider.dataset.rmReviewReady = 'true';

      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-n7-review-slide]'));
      var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-n7-review-dot]'));
      var prev = slider.querySelector('[data-n7-review-prev]');
      var next = slider.querySelector('[data-n7-review-next]');
      var current = 0;
      var timer = null;
      var touchStartX = null;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if(slides.length < 2) return;

      function show(index,direction){
        index = (index + slides.length) % slides.length;
        if(index === current) return;
        slides[current].hidden = true;
        slides[current].classList.remove('is-active','is-entering-next','is-entering-prev');
        current = index;
        var active = slides[current];
        active.hidden = false;
        active.classList.add('is-active', direction === 'prev' ? 'is-entering-prev' : 'is-entering-next');
        window.setTimeout(function(){ active.classList.remove('is-entering-next','is-entering-prev'); }, 480);
        dots.forEach(function(dot,i){
          var selected = i === current;
          dot.classList.toggle('is-active',selected);
          if(selected){ dot.setAttribute('aria-current','true'); } else { dot.removeAttribute('aria-current'); }
        });
      }

      function stop(){ if(timer){ window.clearInterval(timer); timer = null; } }
      function start(){
        stop();
        if(reduceMotion || slider.dataset.manualOnly === 'true') return;
        timer = window.setInterval(function(){ show(current + 1,'next'); },5000);
      }
      function restart(){ stop(); start(); }

      if(prev) prev.addEventListener('click',function(){ show(current - 1,'prev'); restart(); });
      if(next) next.addEventListener('click',function(){ show(current + 1,'next'); restart(); });
      dots.forEach(function(dot){
        dot.addEventListener('click',function(){
          var index = parseInt(dot.getAttribute('data-n7-review-dot'),10);
          show(index,index < current ? 'prev' : 'next');
          restart();
        });
      });

      slider.addEventListener('mouseenter',stop);
      slider.addEventListener('mouseleave',start);
      slider.addEventListener('focusin',stop);
      slider.addEventListener('focusout',function(e){ if(!slider.contains(e.relatedTarget)) start(); });
      slider.addEventListener('touchstart',function(e){ touchStartX = e.touches && e.touches[0] ? e.touches[0].clientX : null; },{passive:true});
      slider.addEventListener('touchend',function(e){
        if(touchStartX === null || !e.changedTouches || !e.changedTouches[0]) return;
        var delta = e.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if(Math.abs(delta) < 40) return;
        show(current + (delta < 0 ? 1 : -1),delta < 0 ? 'next' : 'prev');
        restart();
      },{passive:true});

      start();
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',function(){ initReviewSliders(document); });
  } else {
    initReviewSliders(document);
  }
  document.addEventListener('shopify:section:load',function(event){ initReviewSliders(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-n7-story"] && !Shopify.designMode) return;
  try {
    
(function(){function init(){document.querySelectorAll('[data-n7-video]').forEach(v=>{if(v.dataset.ready)return;v.dataset.ready='true';const copy=JSON.parse(v.closest('.n7-story').querySelector('[data-n7-copy]').textContent);const p=v.parentElement.querySelector('[data-n7-pause]'),s=v.parentElement.querySelector('[data-n7-sound]');let userPaused=false;v.muted=true;function load(){const src=v.querySelector('source');if(!src.src){src.src=src.dataset.src;v.load()}}function update(){p.textContent=v.paused?copy.s0:copy.s1;s.textContent=v.muted?copy.s2:copy.s3;s.setAttribute('aria-pressed',String(!v.muted))}function play(){load();v.play().catch(update)}p.addEventListener('click',()=>{if(v.paused){userPaused=false;play()}else{userPaused=true;v.pause()}});s.addEventListener('click',()=>{const on=v.muted;document.querySelectorAll('[data-n7-video]').forEach(other=>{if(other!==v)other.muted=true});v.muted=!on;update()});['play','pause','volumechange'].forEach(e=>v.addEventListener(e,update));v.addEventListener('ratechange',()=>{if(v.playbackRate!==1)v.playbackRate=1});v.addEventListener('contextmenu',e=>e.preventDefault());if('IntersectionObserver' in window)new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting&&!userPaused)play();else v.pause()}),{threshold:.25}).observe(v);else play();update()})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-product-conversion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-rm-conversion-story]');
    if (!sections.length) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach((section) => {
      const items = section.querySelectorAll('.rm-reveal');
      if (reduced || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.14 });
      items.forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-supplier-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initReviewSliders(scope){
    (scope || document).querySelectorAll('[data-rm-review-slider]').forEach(function(slider){
      if(slider.dataset.rmReviewReady === 'true') return;
      slider.dataset.rmReviewReady = 'true';

      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-rm-review-slide]'));
      var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-rm-review-dot]'));
      var prev = slider.querySelector('[data-rm-review-prev]');
      var next = slider.querySelector('[data-rm-review-next]');
      var current = 0;
      var timer = null;
      var touchStartX = null;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if(slides.length < 2) return;

      function show(index,direction){
        index = (index + slides.length) % slides.length;
        if(index === current) return;
        slides[current].hidden = true;
        slides[current].classList.remove('is-active','is-entering-next','is-entering-prev');
        current = index;
        var active = slides[current];
        active.hidden = false;
        active.classList.add('is-active', direction === 'prev' ? 'is-entering-prev' : 'is-entering-next');
        window.setTimeout(function(){ active.classList.remove('is-entering-next','is-entering-prev'); }, 480);
        dots.forEach(function(dot,i){
          var selected = i === current;
          dot.classList.toggle('is-active',selected);
          if(selected){ dot.setAttribute('aria-current','true'); } else { dot.removeAttribute('aria-current'); }
        });
      }

      function stop(){ if(timer){ window.clearInterval(timer); timer = null; } }
      function start(){
        stop();
        if(reduceMotion || slider.dataset.manualOnly === 'true') return;
        timer = window.setInterval(function(){ show(current + 1,'next'); },5000);
      }
      function restart(){ stop(); start(); }

      if(prev) prev.addEventListener('click',function(){ show(current - 1,'prev'); restart(); });
      if(next) next.addEventListener('click',function(){ show(current + 1,'next'); restart(); });
      dots.forEach(function(dot){
        dot.addEventListener('click',function(){
          var index = parseInt(dot.getAttribute('data-rm-review-dot'),10);
          show(index,index < current ? 'prev' : 'next');
          restart();
        });
      });

      slider.addEventListener('mouseenter',stop);
      slider.addEventListener('mouseleave',start);
      slider.addEventListener('focusin',stop);
      slider.addEventListener('focusout',function(e){ if(!slider.contains(e.relatedTarget)) start(); });
      slider.addEventListener('touchstart',function(e){ touchStartX = e.touches && e.touches[0] ? e.touches[0].clientX : null; },{passive:true});
      slider.addEventListener('touchend',function(e){
        if(touchStartX === null || !e.changedTouches || !e.changedTouches[0]) return;
        var delta = e.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if(Math.abs(delta) < 40) return;
        show(current + (delta < 0 ? 1 : -1),delta < 0 ? 'next' : 'prev');
        restart();
      },{passive:true});

      start();
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',function(){ initReviewSliders(document); });
  } else {
    initReviewSliders(document);
  }
  document.addEventListener('shopify:section:load',function(event){ initReviewSliders(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["romalta-ups-demo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = () => document.querySelectorAll('.rm-ups-demo__frame').forEach(frame => {
      if (frame.dataset.ready) return;
      frame.dataset.ready = 'true';
      const video = frame.querySelector('video');
      const button = frame.querySelector('button');
      let userPaused = false;
      let visible = true;
      const sync = () => { button.textContent = video.paused ? button.dataset.play : button.dataset.pause; };
      const play = () => { if (!userPaused && visible && !document.hidden) video.play().catch(sync); };
      video.muted = true;
      video.controls = false;
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('contextmenu', event => event.preventDefault());
      button.addEventListener('click', () => {
        if (video.paused) { userPaused = false; video.play().catch(sync); }
        else { userPaused = true; video.pause(); }
      });
      if ('IntersectionObserver' in window) new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) play(); else video.pause();
      }, { threshold: 0.1 }).observe(video);
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else play(); });
      sync();
      play();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
    else setup();
    document.addEventListener('shopify:section:load', setup);
  })();

  } catch(e) { console.error(e); }
})();
})();
